var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _g2, _path8, _g3, _path9, _g4, _path0, _g5, _path1, _g6, _path10, _g7, _path11, _g8, _path12, _g9, _path13, _g0, _path14, _g1, _path15, _g10, _path16, _g11, _path17, _g12, _path18, _g13, _path19, _g14, _path20, _g15, _path21, _g16, _path22, _g17, _path23, _g18, _path24, _g19, _path25, _g20, _path26, _g21, _path27, _g22, _path28, _g23, _path29, _g24, _path30, _g25, _path31, _g26, _path32, _g27, _path33, _g28, _path34, _g29, _path35, _g30, _path36, _g31, _path37, _g32, _path38, _g33, _path39, _g34, _path40, _g35, _path41, _g36, _path42, _g37, _path43, _g38, _path44, _g39, _path45, _g40, _path46, _g41, _path47, _g42, _path48, _g43, _path49, _g44, _path50, _g45, _path51, _g46, _path52, _g47, _path53, _g48, _path54, _g49, _path55, _g50, _path56, _g51, _path57, _g52, _path58, _g53, _path59, _g54, _path60, _g55, _path61, _g56, _path62, _g57, _path63, _g58, _path64, _g59, _path65, _g60, _path66, _g61, _path67, _g62, _path68, _g63, _path69, _g64, _path70, _g65, _path71, _g66, _path72, _g67, _path73, _g68, _path74, _g69, _path75, _g70, _path76, _g71, _path77, _g72, _path78, _g73, _path79, _g74, _path80, _g75, _path81, _g76, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMbrifLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 33,
    viewBox: "0 0 92 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2976_18362)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.11501 2.45008L20.3932 2.44412V20.7228L2.11501 20.7277V2.45008ZM22.5087 0.328613L0 0.335575V22.8447L22.5087 22.8368V0.328613Z",
    fill: "#004AF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3591 11.6703L29.6378 11.6648V29.9375L11.3591 29.9425V11.6703ZM9.24463 9.5558V32.0635H11.9455L31.7528 32.057V9.54834L9.24463 9.5558Z",
    fill: "#004AF4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7393 12.9885V12.5285C39.158 12.5285 39.1421 12.1873 39.1421 11.9078V10.3389H39.6468C39.6468 10.3389 39.6548 10.3836 39.6468 12.1177C39.6468 12.5653 39.3594 13.0089 38.7393 12.9885Z",
    fill: "#004AF4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0474 11.4085V9.58838H40.5611V11.3956C40.5611 11.6462 40.6759 11.7785 41.0295 11.7785V12.2509C40.3845 12.2509 40.0479 11.9297 40.0479 11.408",
    fill: "#004AF4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8633 12.2517V11.7793H42.4651V11.282C42.4651 11.0483 42.3994 10.9379 42.1861 10.9379H40.9414V10.2964C40.9414 9.86917 41.286 9.59814 41.7828 9.59814H42.5919V10.0706H41.7833C41.5451 10.0706 41.4387 10.1775 41.4387 10.3048V10.461H42.207C42.7286 10.461 42.9793 10.7489 42.9793 11.2701V11.7793H43.3363V12.2517H40.8633Z",
    fill: "#004AF4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1704 9.46387H43.5896V9.97757H43.1704V9.46387ZM44.5922 12.2532C44.3366 12.2532 44.1307 12.1791 43.9696 12.0518C43.8214 12.1876 43.607 12.2532 43.3599 12.2532H43.2117V11.7808H43.3599C43.5737 11.7808 43.6936 11.6659 43.6936 11.4849V10.3346H44.2132V11.4968C44.2132 11.6694 44.3366 11.7803 44.5922 11.7803H44.7404V12.2532H44.5922ZM43.7866 9.46387H44.2053V9.97757H43.7866V9.46387Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.6128 12.2488H45.3806V11.7764H44.6128V12.2488Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.269 12.2488H46.0369V11.7764H45.269V12.2488Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9204 11.7801C46.2735 11.7801 46.4381 11.6528 46.4381 11.4101V10.334H46.9513V11.435C46.9513 11.9403 46.557 12.2526 45.9204 12.2526V11.7801ZM46.3023 12.5683H46.8245V13.087H46.3023V12.5683Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.488 12.2504C49.2626 12.253 49.0433 12.1775 48.8674 12.0366H48.8594C48.7197 12.1758 48.5183 12.2504 48.2925 12.2504H47.3477V11.778H47.6928V9.59634H48.2184V11.778H48.2841C48.383 11.778 48.5059 11.6954 48.5556 11.5845C48.6088 11.4488 48.6003 11.3011 48.6003 11.1658V9.58838H49.1141V11.3916C49.1141 11.4368 49.1141 11.4781 49.1096 11.5149C49.122 11.675 49.2453 11.778 49.4875 11.778H49.6357V12.2504H49.488Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5156 12.2517V11.7793C49.8687 11.7793 50.0328 11.648 50.0328 11.4053V9.59814H50.5465V11.4342C50.5465 11.9394 50.1522 12.2517 49.5156 12.2517Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.6489 12.2511V11.7787H52.5202V11.2247C52.5202 10.8547 52.4292 10.7602 52.1785 10.7602L52.2691 10.3042C52.7952 10.3042 53.0249 10.5588 53.0249 11.0556V11.7787H53.5506V12.2511H51.6489Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.4297 12.2488H54.1975V11.7764H53.4297V12.2488Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.0811 12.2488H54.8489V11.7764H54.0811V12.2488Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.7227 12.2527V11.7797H55.3721V10.3341H55.8724V11.7797H56.5383V10.3341H57.0604V11.7797H57.3474C57.4956 11.7797 57.5612 11.7678 57.5612 11.3938V10.3341H58.0705V11.546C58.0705 12.006 57.8034 12.2522 57.3593 12.2522L54.7227 12.2527ZM56.2752 9.46282H56.686V9.97653H56.2752V9.46282ZM56.5711 8.84717H56.9903V9.29474H56.5711V8.84717ZM56.8874 9.46332H57.3071V9.97653H56.8874V9.46332Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.4673 12.2504V9.58838H58.981V12.2504H58.4673Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.1489 12.9885V12.5285C59.5677 12.5285 59.5517 12.1873 59.5517 11.9078V10.3389H60.057C60.057 10.3389 60.0649 10.3836 60.057 12.1177C60.057 12.5653 59.7691 13.0089 59.1489 12.9885Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.3925 12.2532C63.212 12.2532 63.0558 12.208 62.9285 12.1294V12.1463C62.9285 12.6431 62.5794 12.9803 62.0985 12.9882C62.0493 12.9882 62.0244 12.9927 61.9881 12.9882C61.5112 12.9803 61.1626 12.6391 61.1626 12.1418V10.3346H61.6753V12.1299C61.6753 12.376 61.7907 12.5078 62.0493 12.5078C62.3084 12.5078 62.4113 12.376 62.4113 12.1299V10.3346H62.9285V11.4277C62.9285 11.6535 63.1215 11.7808 63.3925 11.7808H63.4546V12.2532H63.3925ZM61.7783 9.46387H62.2959V9.97757H61.7783V9.46387Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.3311 12.2488H64.0994V11.7764H63.3311V12.2488Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.9819 11.7801C64.335 11.7801 64.4991 11.6528 64.4991 11.4101V10.334H65.0128V11.435C65.0128 11.9403 64.6185 12.2526 63.9819 12.2526V11.7801ZM64.3639 12.5683H64.886V13.087H64.3639V12.5683Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.1157 12.2511V11.7787H66.987V11.2247C66.987 10.8547 66.896 10.7602 66.6453 10.7602L66.7359 10.3042C67.262 10.3042 67.4917 10.5588 67.4917 11.0556V11.7787H68.0174V12.2511H66.1157Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.896 12.2488H68.6643V11.7764H67.896V12.2488Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.5474 12.2488H69.3152V11.7764H68.5474V12.2488Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.3196 12.1422C71.1799 12.4341 70.9213 12.6022 70.5597 12.6022C70.2106 12.5982 69.9436 12.4381 69.8038 12.1626C69.6619 12.226 69.5077 12.2569 69.3523 12.2531H69.2041V11.7806C69.4055 11.7687 69.6477 11.7722 69.6686 11.526C69.7014 10.9303 70.0092 10.5483 70.5597 10.5483C71.1306 10.5483 71.435 10.988 71.435 11.526C71.435 11.6981 71.5578 11.7806 71.8129 11.7806H71.9601V12.2531C71.7468 12.2531 71.5126 12.2406 71.3196 12.1422ZM70.5622 10.9835C70.3514 10.9835 70.2106 11.1272 70.2106 11.5628C70.2106 11.986 70.3514 12.1297 70.5622 12.1297C70.7731 12.1297 70.9138 11.982 70.9138 11.5753C70.9138 11.1272 70.7731 10.9835 70.5622 10.9835Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.8799 12.2512V11.7788H73.1739C73.1326 10.7439 72.1261 10.8095 72.1261 10.8095V10.354C73.2067 10.354 73.6627 10.9985 73.691 11.7793H74.2172V12.2517L71.8799 12.2512Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.0923 12.2488H74.8601V11.7764H74.0923V12.2488Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.7485 12.2488H75.5164V11.7764H74.7485V12.2488Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.7108 12.2496C76.4557 12.2496 76.2299 12.1635 76.0986 11.9462C75.9792 12.1715 75.7167 12.2496 75.4004 12.2496V11.7771C75.8355 11.7771 75.8231 11.3703 75.8355 11.0993C75.8649 10.5573 76.1971 10.1997 76.7108 10.1997C77.2692 10.1997 77.586 10.611 77.586 11.2266C77.586 11.8473 77.2737 12.2496 76.7108 12.2496ZM76.7108 10.6353C76.5054 10.6353 76.3656 10.7835 76.3656 11.2351C76.3656 11.6662 76.5009 11.8139 76.7108 11.8139C76.9196 11.8139 77.0599 11.6618 77.0599 11.2391C77.0599 10.7835 76.9201 10.6353 76.7108 10.6353Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.1803 11.6818C79.1803 12.6883 80.2689 12.8236 80.5603 12.2368C80.4375 12.2776 80.3922 12.286 80.3266 12.286C79.7676 12.286 79.4514 11.9697 79.4514 11.3163C79.4514 10.6842 79.7761 10.3058 80.3266 10.3058C80.8726 10.3058 81.2013 10.6718 81.2013 11.3039V11.5998C81.2013 13.5676 78.6875 13.3701 78.6875 11.6818H79.1803ZM79.7597 9.46387H80.2237V9.97757H79.7597V9.46387ZM79.9651 11.3083C79.9651 11.7231 80.1003 11.8051 80.3266 11.8051C80.5524 11.8051 80.6876 11.7151 80.6876 11.3168C80.6876 10.8767 80.5439 10.7578 80.3266 10.7578C80.1088 10.7578 79.9651 10.8772 79.9651 11.3083ZM80.4206 9.46387H80.8846V9.97757H80.4206V9.46387Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.3591 12.5528C82.5566 12.5528 82.8853 12.4832 82.8728 12.1008C82.8112 12.2032 82.6714 12.3678 82.38 12.3678C81.8459 12.3678 81.5913 12.0267 81.5913 11.3613C81.5913 10.7168 81.8912 10.3389 82.4253 10.3389H83.2672V12.1212C83.2672 12.6921 82.9017 13.0009 82.3552 12.98L82.3591 12.5528ZM82.7585 10.7944H82.4651C82.1627 10.7944 82.105 11.1395 82.105 11.3534C82.105 11.5751 82.109 11.9158 82.4357 11.9158C82.7714 11.9158 82.759 11.6035 82.759 11.3737L82.7585 10.7944Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.6655 12.2511V11.7787H84.5368V11.2247C84.5368 10.8547 84.4458 10.7602 84.1951 10.7602L84.2857 10.3042C84.8118 10.3042 85.0415 10.5588 85.0415 11.0556V11.7787H85.5672V12.2511H83.6655Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.4463 12.2488H86.2146V11.7764H85.4463V12.2488Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.0967 12.2488H86.8645V11.7764H86.0967V12.2488Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.1289 12.2532C87.8748 12.2532 87.6694 12.1791 87.5093 12.0518C87.3611 12.1876 87.1473 12.2532 86.9011 12.2532H86.7534V11.7808H86.9011C87.115 11.7808 87.2338 11.6659 87.2338 11.4849V10.3346H87.751V11.4968C87.751 11.6694 87.8748 11.7803 88.1289 11.7803H88.2771V12.2532H88.1289ZM87.2258 9.46387H87.748V9.97757H87.2258V9.46387Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.1509 12.2488H88.9192V11.7764H88.1509V12.2488Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.872 12.2526H88.8022V11.7801H89.4512V10.334H89.9525V11.0983C90.1494 10.7487 90.4737 10.3797 90.9794 10.3797C91.5752 10.3797 91.8089 10.881 91.8089 11.246C91.8044 11.5708 91.6284 12.2526 90.872 12.2526ZM90.9665 10.8353C90.4776 10.8353 90.2275 11.4106 90.1002 11.7801H90.8725C91.1435 11.7801 91.2917 11.5464 91.2917 11.2381C91.2917 11.0327 91.1843 10.8353 90.967 10.8353",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7132 17.5788L41.6152 16.4748C41.6003 16.3007 41.5869 16.1122 41.5869 15.9198H41.5769C41.5068 16.1122 41.4128 16.3146 41.3233 16.4887L40.7599 17.5882H40.4685L39.8996 16.4887C39.8101 16.3146 39.7205 16.1177 39.6459 15.9252H39.636C39.636 16.1217 39.6221 16.3057 39.6081 16.4748L39.5137 17.5788H38.814L39.0726 14.5811H39.6643L40.3178 15.8402C40.4073 16.0143 40.5386 16.2818 40.6187 16.4792H40.6286C40.7032 16.2818 40.8116 16.0471 40.9145 15.8402L41.563 14.5811H42.1598L42.4278 17.5788H41.7132Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.4389 17.6507C43.6119 17.6507 42.8271 17.0445 42.8271 16.0762C42.8271 15.1174 43.6119 14.5117 44.4389 14.5117C45.2709 14.5117 46.0556 15.1174 46.0556 16.0762C46.0556 17.0445 45.2704 17.6507 44.4389 17.6507ZM44.4414 15.1507C43.9888 15.1507 43.5651 15.5178 43.5651 16.0762C43.5651 16.6406 43.9893 17.0067 44.4414 17.0067C44.8939 17.0067 45.3231 16.6406 45.3231 16.0767C45.3231 15.5178 44.8939 15.1507 44.4414 15.1507Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4161 17.5788V16.3897H47.2554V17.5788H46.5273V14.5811H47.2554V15.7646H48.4161V14.5811H49.1401V17.5788H48.4161Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.674 17.5821L51.4388 16.9575H50.4522L50.2219 17.5821H49.5356L50.7152 14.561H51.2185L52.3976 17.5821H51.674ZM51.0439 15.8058C51.0074 15.7057 50.9762 15.6038 50.9505 15.5004H50.9405C50.9171 15.6044 50.8858 15.7065 50.847 15.8058L50.6307 16.4075H51.2603L51.0439 15.8058Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6527 17.5788L55.5547 16.4748C55.5398 16.3007 55.5263 16.1122 55.5263 15.9198H55.5164C55.4463 16.1122 55.3523 16.3146 55.2628 16.4887L54.6988 17.5882H54.4074L53.839 16.4887C53.7495 16.3146 53.66 16.1177 53.5854 15.9252H53.5755C53.5755 16.1217 53.5615 16.3057 53.5476 16.4748L53.4531 17.5788H52.7534L53.012 14.5811H53.6038L54.2572 15.8402C54.3468 16.0143 54.478 16.2818 54.5576 16.4792H54.5676C54.6422 16.2818 54.7506 16.0471 54.854 15.8402L55.5025 14.5811H56.0992L56.3673 17.5788H55.6527Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.7601 17.5788L59.6621 16.4748C59.6472 16.3007 59.6338 16.1122 59.6338 15.9198H59.6238C59.5537 16.1122 59.4597 16.3146 59.3702 16.4887L58.8063 17.5882H58.5153L57.9464 16.4887C57.8569 16.3146 57.7674 16.1177 57.6928 15.9252H57.6829C57.6829 16.1217 57.6689 16.3057 57.655 16.4748L57.5605 17.5788H56.8608L57.1194 14.5811H57.7112L58.3647 15.8402C58.4542 16.0143 58.5855 16.2818 58.665 16.4792H58.675C58.7496 16.2818 58.858 16.0471 58.9614 15.8402L59.6099 14.5811H60.2067L60.4747 17.5788H59.7601Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.0186 17.5788V14.5811H62.7666V15.1778H61.7471V15.7746H62.5791V16.3808H61.7466V16.982H62.8983V17.5788H61.0186Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.3513 17.5798H63.3408V14.5811H64.3513C65.2156 14.5811 65.9586 15.145 65.9586 16.0799C65.9586 17.0148 65.2156 17.5798 64.3513 17.5798ZM64.2668 15.2062H64.041V16.9542H64.2668C64.7884 16.9542 65.2301 16.6632 65.2301 16.0799C65.2301 15.4976 64.7884 15.2062 64.2668 15.2062Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.7603 17.5798H67.6274V14.5811H68.6335C69.1029 14.5811 69.5117 14.8869 69.5117 15.3752C69.5117 15.5543 69.4227 15.784 69.2631 15.8735C69.5167 15.9531 69.7842 16.2868 69.7842 16.6493C69.7842 17.2316 69.3237 17.5793 68.7598 17.5793M68.5226 15.1166H68.2898V15.7233H68.5226C68.6931 15.7233 68.8543 15.6388 68.8543 15.4225C68.8543 15.2062 68.6931 15.1166 68.5226 15.1166ZM68.6379 16.2589H68.2898V17.0347H68.6379C68.8632 17.0347 69.079 16.9174 69.079 16.6493C69.079 16.3857 68.8632 16.2589 68.6379 16.2589Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.3325 17.5793H71.0606V14.5811H70.3325V17.5793Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.1684 17.6126L73.0032 16.334C72.8107 16.1201 72.6242 15.9009 72.4438 15.6766L72.4343 15.6806C72.4443 15.8924 72.4483 16.1232 72.4483 16.3107V17.5798H71.7202V14.5811H72.307L73.3225 15.7C73.4632 15.8551 73.6746 16.0988 73.8109 16.2734L73.8208 16.2684C73.8109 16.0894 73.8064 15.8969 73.8064 15.7094V14.5811H74.5349V17.6126H74.1684Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.0623 17.5798L77.2542 16.4002H76.9956V17.5798H76.2954V14.5811H77.4138C77.9261 14.5811 78.3816 14.9242 78.3816 15.4881C78.3816 15.8407 78.1752 16.1227 77.9216 16.24L78.8754 17.5798H78.0623ZM76.9956 15.1544V15.8268H77.3059C77.4939 15.8268 77.6814 15.7228 77.6814 15.4881C77.6814 15.2624 77.4939 15.1549 77.3059 15.1549L76.9956 15.1544Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.0598 17.5821L80.8245 16.9575H79.8379L79.6077 17.5821H78.9214L80.101 14.561H80.6042L81.7833 17.5821H81.0598ZM80.4297 15.8058C80.3931 15.7057 80.3619 15.6038 80.3362 15.5004H80.3263C80.3028 15.6044 80.2716 15.7065 80.2328 15.8058L80.0164 16.4075H80.646L80.4297 15.8058Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.0318 17.6498C82.6608 17.6498 82.3406 17.5563 82.1252 17.3961L82.0591 16.6959C82.35 16.9262 82.6648 17.0391 82.999 17.0391C83.2665 17.0391 83.4172 16.9262 83.4172 16.7477C83.4172 16.5691 83.3138 16.4801 82.9428 16.3483C82.4206 16.1648 82.1436 15.8311 82.1436 15.4179C82.1436 14.9107 82.5241 14.5063 83.182 14.5063C83.5535 14.5063 83.7837 14.6003 83.915 14.6849L83.8588 15.2961C83.6731 15.178 83.4587 15.1128 83.2387 15.1076C82.9801 15.1076 82.8577 15.2205 82.8577 15.3662C82.8577 15.5074 82.9612 15.5964 83.3182 15.7143C83.7976 15.8734 84.1497 16.2076 84.1497 16.678C84.1497 17.2649 83.7693 17.6498 83.0318 17.6498Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.5245 17.5788V16.3897H85.3633V17.5788H84.6348V14.5811H85.3633V15.7646H86.524V14.5811H87.2476V17.5788H86.5245Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.9072 17.5793H88.6353V14.5811H87.9072V17.5793Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.3049 17.5798H89.2949V14.5811H90.3049C91.1697 14.5811 91.9122 15.145 91.9122 16.0799C91.9122 17.0148 91.1697 17.5798 90.3049 17.5798ZM90.2204 15.2062H89.9951V16.9542H90.2204C90.7426 16.9542 91.1837 16.6632 91.1837 16.0799C91.1837 15.4976 90.7421 15.2062 90.2204 15.2062Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.998 22.6039H39.9454V18.7036H38.998V22.6039Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9235 22.6467L42.4077 20.9837C42.1576 20.7051 41.915 20.4199 41.6802 20.1284L41.6677 20.1343C41.6802 20.4093 41.6861 20.7092 41.6861 20.9539V22.6039H40.7388V18.7036H41.5026L42.8229 20.1587C43.0428 20.4007 43.2551 20.6495 43.4595 20.9047L43.4714 20.8987C43.4591 20.6562 43.453 20.4134 43.453 20.1706V18.7036H44.4004V22.6467H43.9235Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.379 22.6467L46.8633 20.9837C46.6132 20.7051 46.3706 20.4199 46.1357 20.1284L46.1233 20.1343C46.1357 20.4093 46.1417 20.7092 46.1417 20.9539V22.6039H45.1943V18.7036H45.9582L47.2785 20.1587C47.4984 20.4007 47.7107 20.6495 47.915 20.9047L47.9265 20.8987C47.9145 20.6562 47.9085 20.4134 47.9086 20.1706V18.7036H48.8559V22.6467H48.379Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.5629 22.6981C50.4868 22.6981 49.4663 21.9093 49.4663 20.6502C49.4663 19.403 50.4868 18.6143 51.5629 18.6143C52.645 18.6143 53.6655 19.403 53.6655 20.6502C53.6655 21.9093 52.645 22.6981 51.5629 22.6981ZM51.5629 19.4457C50.9761 19.4457 50.4256 19.9226 50.4256 20.6502C50.4256 21.3832 50.9756 21.8601 51.5629 21.8601C52.1497 21.8601 52.7062 21.3832 52.7062 20.6502C52.7062 19.9226 52.1497 19.4457 51.5629 19.4457Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.0038 22.6278H55.228L53.8032 18.7036H54.7749L55.3866 20.4208C55.4781 20.6779 55.5696 20.9957 55.6427 21.2891H55.6557C55.7288 20.9957 55.8203 20.6774 55.9123 20.4208L56.5234 18.7036H57.4221L56.0038 22.6278Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.7267 22.6045L59.4214 21.7919H58.1373L57.8375 22.6045H56.9453L58.4795 18.6738H59.1334L60.6681 22.6045H59.7267ZM58.9072 20.294C58.8594 20.1637 58.8185 20.0309 58.7848 19.8962H58.7729C58.742 20.0374 58.6933 20.1841 58.6505 20.294L58.3696 21.0763H59.1886L58.9072 20.294Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.5731 19.462V22.6039H61.6317V19.455H60.4517V18.7036H63.7472V19.462H62.5731Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.4497 22.6039H65.3971V18.7036H64.4497V22.6039Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.227 22.6981C67.1513 22.6981 66.1304 21.9093 66.1304 20.6502C66.1304 19.403 67.1513 18.6143 68.227 18.6143C69.3091 18.6143 70.3305 19.403 70.3305 20.6502C70.3305 21.9093 69.3091 22.6981 68.227 22.6981ZM68.2295 19.4457C67.6417 19.4457 67.0902 19.9226 67.0902 20.6502C67.0902 21.3832 67.6417 21.8601 68.2295 21.8601C68.8178 21.8601 69.3752 21.3832 69.3752 20.6502C69.3752 19.9226 68.8183 19.4457 68.2295 19.4457Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.1837 22.6467L72.667 20.9837C72.4171 20.7051 72.1747 20.4198 71.9399 20.1284L71.9275 20.1343C71.9399 20.4093 71.9459 20.7092 71.9459 20.9539V22.6039H70.9985V18.7036H71.7629L73.0832 20.1587C73.2667 20.3601 73.5417 20.6779 73.7192 20.9047L73.7312 20.8987C73.7189 20.6562 73.7127 20.4134 73.7128 20.1706V18.7036H74.6606V22.6467H74.1837Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.8394 19.4804V20.2562H78.9768V21.0454H77.8394V22.6039H76.8921V18.7036H79.2209V19.4804H77.8394Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask59_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.5184 22.6895C80.5894 22.6895 79.8311 22.1394 79.8311 21.2712V18.7036H80.7789V21.1856C80.7789 21.5835 81.0783 21.858 81.5308 21.858C81.9834 21.858 82.2887 21.583 82.2887 21.1856V18.7036H83.2117V21.2712C83.2117 22.1394 82.4538 22.6895 81.5184 22.6895Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.194 22.6467L85.6777 20.9837C85.4275 20.7052 85.1849 20.42 84.9502 20.1284L84.9382 20.1343C84.9502 20.4093 84.9566 20.7092 84.9566 20.9539V22.6039H84.0088V18.7036H84.7731L86.0935 20.1587C86.277 20.3601 86.552 20.6779 86.7295 20.9047L86.7414 20.8987C86.7291 20.6562 86.723 20.4134 86.723 20.1706V18.7036H87.6709V22.6467H87.194Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.7782 22.6039H88.4644V18.7036H89.7782C90.9036 18.7036 91.8693 19.4371 91.8693 20.6535C91.8693 21.8699 90.9036 22.6039 89.7782 22.6039ZM89.6688 19.5167H89.3754V21.7963H89.6688C90.3471 21.7963 90.922 21.4159 90.922 20.656C90.922 19.8961 90.3471 19.5167 89.6688 19.5167Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.979 27.16H39.0844V25.4468H38.979V27.16Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.1816 25.4468H41.2796L42.2568 26.7905C42.3125 26.8686 42.396 27.0058 42.396 27.0058H42.401C42.401 27.0058 42.3886 26.8765 42.3886 26.7905V25.4468H42.494V27.16H42.396L41.4194 25.8163C41.3707 25.7458 41.3241 25.674 41.2796 25.6009H41.2746C41.2746 25.6009 41.2871 25.7302 41.2871 25.8163V27.16H41.1816V25.4468Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.5923 25.4468H44.6903L45.6669 26.7905C45.7231 26.8686 45.8062 27.0058 45.8062 27.0058H45.8112C45.8112 27.0058 45.7992 26.8765 45.7992 26.7905V25.4468H45.9047V27.16H45.8062L44.83 25.8163C44.7814 25.7458 44.7348 25.674 44.6903 25.6009H44.6853C44.6853 25.6009 44.6977 25.7302 44.6977 25.8163V27.16H44.5923V25.4468Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask65_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7462 25.4175C49.2236 25.4175 49.613 25.7994 49.613 26.2912C49.613 26.7955 49.2236 27.1894 48.7462 27.1894C48.2688 27.1894 47.8799 26.7955 47.8799 26.2912C47.8799 25.7989 48.2688 25.4175 48.7462 25.4175ZM48.7462 27.0889C49.1644 27.0889 49.5026 26.7418 49.5026 26.2912C49.5026 25.8531 49.1644 25.5179 48.7462 25.5179C48.3275 25.5179 47.9903 25.8531 47.9903 26.2912C47.9903 26.7418 48.3275 27.0889 48.7462 27.0889Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.356 25.4468H51.4683L51.985 26.8318C52.0144 26.9128 52.0512 27.0376 52.0512 27.0376H52.0562C52.0562 27.0376 52.0925 26.9133 52.1223 26.8322L52.641 25.4468H52.7534L52.1123 27.16H51.9975L51.356 25.4468Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask67_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.3942 26.5682H54.6672L54.4469 27.16H54.3345L54.976 25.4468H55.0884L55.7299 27.16H55.6175L55.3942 26.5682ZM55.0322 25.5691C55.0322 25.5691 54.9949 25.7014 54.968 25.7755L54.7045 26.4702H55.3624L55.1013 25.7755C55.0778 25.7073 55.0563 25.6385 55.0367 25.5691H55.0322Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask68_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.888 25.5447H57.249V25.4468H58.6325V25.5447H57.9935V27.16H57.888V25.5447Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask69_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.4814 25.4468H61.4188V25.5447H60.5869V26.2469H61.2697V26.3449H60.5869V27.062H61.4656V27.16H60.4814V25.4468Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask70_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7401 25.5447H65.1011V25.4468H66.4846V25.5447H65.8455V27.16H65.7401V25.5447Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask71_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.3384 25.4468H68.4438V26.2524H69.5304V25.4468H69.6353V27.16H69.5309V26.3504H68.4438V27.16H68.3384V25.4468Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask72_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.7305 25.4468H72.6679V25.5447H71.8359V26.2469H72.5187V26.3449H71.8359V27.062H72.7146V27.16H71.7305V25.4468Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask73_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.5051 25.596C77.5051 25.596 77.4708 25.7576 77.4395 25.8675L77.0765 27.1605H76.9447L76.4941 25.4468H76.6045L76.9666 26.8417C76.9889 26.9252 77.0078 27.0257 77.0078 27.0257H77.0128C77.0158 27.0257 77.0352 26.9277 77.0596 26.8417L77.4514 25.4468H77.5688L77.9602 26.8417C77.985 26.9277 78.0044 27.0257 78.0069 27.0257H78.0119C78.0119 27.0257 78.0318 26.9252 78.0537 26.8417L78.4281 25.4468H78.5385L78.0755 27.16H77.9433L77.5812 25.8675C77.5565 25.7777 77.5344 25.6871 77.5151 25.596H77.5101H77.5051Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask74_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.2144 25.4175C81.6918 25.4175 82.0812 25.7994 82.0812 26.2912C82.0812 26.7955 81.6918 27.1894 81.2144 27.1894C80.737 27.1894 80.3481 26.7955 80.3481 26.2912C80.3481 25.7989 80.737 25.4175 81.2144 25.4175ZM81.2144 27.0889C81.6327 27.0889 81.9708 26.7418 81.9708 26.2912C81.9708 25.8531 81.6327 25.5179 81.2144 25.5179C80.7957 25.5179 80.4585 25.8531 80.4585 26.2912C80.4585 26.7418 80.7957 27.0889 81.2144 27.0889Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask75_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.0581 25.4468H84.5604C84.7195 25.4468 84.8001 25.4642 84.8687 25.498C85.0109 25.5686 85.1059 25.7133 85.1059 25.9093C85.1059 26.1539 84.9642 26.3374 84.7628 26.3817V26.3867C84.7628 26.3867 84.7802 26.4061 84.8026 26.4478L85.1865 27.16H85.0621L84.6559 26.4016H84.1635V27.16H84.0581V25.4468ZM84.6315 26.2982C84.8583 26.2982 85.001 26.138 85.001 25.9068C85.001 25.7561 84.9244 25.6343 84.7991 25.5786C84.7494 25.5572 84.6956 25.5447 84.5579 25.5447H84.1635V26.2982H84.6315Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask76_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.1465 25.4468H87.2519V27.062H88.0695V27.16H87.1465V25.4468Z",
    fill: "#004AF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask77_2976_18362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 33
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0661H91.9115V0.328613H0V32.0661Z",
    fill: "white"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_2976_18362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.9556 25.4468H90.4946C91.0039 25.4468 91.3485 25.7601 91.3485 26.3031C91.3485 26.8492 91.0039 27.16 90.4946 27.16H89.9556V25.4468ZM90.4772 27.062C90.9328 27.062 91.2381 26.7954 91.2381 26.3031C91.2381 25.8138 90.9328 25.5447 90.4772 25.5447H90.061V27.062H90.4772Z",
    fill: "#004AF4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2976_18362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 32.3243,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMbrifLogo);
export default __webpack_public_path__ + "static/media/mbrif-logo.0ba51cf66e7a63dee649199fb5e21e8d.svg";
export { ForwardRef as ReactComponent };